import { converterFatorEmbalagem, converterPrecoUnidade } from './validacao'

// Os dois campos da caixa fechada, do jeito que eles VIAJAM no payload da
// importacao. Mora aqui, e nao solto dentro do `map` de ImportarArquivo.tsx,
// porque a tela tem hook e nenhum teste desta suite a alcanca -- e o que esta
// escrito abaixo e uma decisao de negocio, nao encanamento.
//
// ⭐ R13, decisao dela em 29/08: COLUNA NAO MAPEADA NAO MEXE NO QUE ESTA
// GRAVADO. Sao tres respostas, e a diferenca entre as duas primeiras e a regra
// inteira:
//   chave AUSENTE = a coluna nao foi mapeada. Ninguem tem opiniao sobre este
//                   campo, entao nao mexa no que ja esta no banco. Como
//                   `JSON.stringify` descarta o que nao existe, basta nao
//                   emitir a chave: a edge recebe `undefined` e pula o campo.
//   null          = a coluna foi mapeada e a celula veio vazia. Isso E uma
//                   opiniao: apague o que estava la.
//   number        = o valor.
//
// Por que importa: a Task 4 vai deixar ela digitar o fator na ficha do produto.
// Sem esta separacao, a proxima importacao de rotina de uma planilha sem a
// coluna devolveria o produto ao estado antigo -- calada, e mudando a conta do
// carrinho no meio de um pedido.
//
// ✅ Seguro para o upsert em lote: o lote inteiro compartilha o MESMO
// mapeamento, entao ou todas as linhas trazem a chave ou nenhuma traz. O payload
// continua homogeneo.
export interface CamposCaixaFechada {
  unidades_por_embalagem?: number | null
  preco_unidade?: number | null
}

export function camposCaixaFechada(campos: Record<string, string>): CamposCaixaFechada {
  const saida: CamposCaixaFechada = {}
  // `in` e nao `?? ''`: e a AUSENCIA da chave que carrega o sentido, e
  // `campos.x ?? ''` apagaria justamente a diferenca que a regra mede.
  // `aplicarMapa` (validacao.ts) so escreve as chaves que o mapa cita -- ha
  // teste provando as duas formas em payloadCaixaFechada.test.ts.
  if ('unidades_por_embalagem' in campos) {
    // `converterFatorEmbalagem` e nao o conversor generico: e ele que sabe que
    // caixa tem numero INTEIRO de unidades dentro. Devolve `undefined` para
    // vazio e `null` para valor sujo, e o `?? null` achata os dois -- achatar e
    // seguro aqui porque este caminho so roda sobre `validacao.validas`, e linha
    // com valor sujo ja foi reprovada por validarProdutos antes de chegar.
    saida.unidades_por_embalagem = converterFatorEmbalagem(campos.unidades_por_embalagem) ?? null
  }
  if ('preco_unidade' in campos) {
    // ⭐ R12: `converterPrecoUnidade` e nao o conversor generico. Com o generico,
    // `'0'` viajava como 0 -- e o check da 0021 e `>= 0`, entao o zero era
    // GRAVADO e a unidade solta passava a ser vendida de graca. Aqui `0` e
    // celula vazia dao o mesmo `undefined`, e o `?? null` os transforma na unica
    // opiniao que faz sentido para os dois: "apague o preco avulso".
    // ⚠ O `?? null` NAO apaga a distincao da R13: quem decide se a chave viaja
    // e o `in` acima, e nao o valor.
    saida.preco_unidade = converterPrecoUnidade(campos.preco_unidade) ?? null
  }
  return saida
}
